module.exports = __webpack_public_path__ + "img/3-white.5fe6c0d8.svg";